import React from "react";
import { FiltersProvider } from "@jsq/ds/refilterable";
import history from "~/utils/history";
import Layout from "./components/Layout";
import IndexRoute from "./routes/index";

export const CCTools: React.FunctionComponent = () => {
  return (
    <FiltersProvider history={history}>
      <Layout>
        <IndexRoute />
      </Layout>
    </FiltersProvider>
  );
};
